import {
  ItemPerRow,
  HeadingType,
  SelectMode,
  MenuMode,
  CardsConfig,
  IconType
} from '@rappider/rappider-components/utils';
import { PreviewGridType } from 'libs/component-definition/src/lib/components/component-definitions-preview/model/preview-grid-type.enum';

/**
 * Default pagination configuration for project information cards
 */
const DEFAULT_PAGINATION_CONFIG = {
  pageIndex: 1,
  total: 0,
  pageSize: 8,
  showPagination: true
};

/**
 * Default select configuration for filtering
 */
const DEFAULT_SELECT_CONFIG = {
  options: [],
  settings: {
    mode: SelectMode.Multiple,
    maxTagCount: 3
  },
  placeholder: 'Filter by Tags',
  visibility: true
};

/**
 * Default menu configuration for category filtering
 */
const DEFAULT_MENU_CONFIG = {
  mode: MenuMode.Vertical,
  items: []
};

/**
 * Grid view buttons configuration for different layout options
 */
const GRID_VIEW_BUTTONS = [
  {
    key: PreviewGridType.Row,
    icon: {
      name: 'fas fa-grip-lines',
      type: IconType.FontAwesome
    },
    tooltipText: 'Single Row View'
  },
  {
    key: PreviewGridType.TwoColumns,
    icon: {
      name: 'fas fa-line-columns',
      type: IconType.FontAwesome
    },
    tooltipText: 'Two Columns View'
  },
  {
    key: PreviewGridType.FourColumns,
    icon: {
      name: 'fa-solid fa-columns-3',
      type: IconType.FontAwesome
    },
    tooltipText: 'Four Columns View'
  }
];

/**
 * Main configuration for project information cards component
 *
 * This configuration defines the default settings for displaying
 * project modules in a card-based interface with filtering and pagination capabilities.
 */
export const projectInformationCardsConfig: CardsConfig = {
  // Layout configuration
  itemCountPerRow: ItemPerRow.Four,
  showTitleOnImage: false,
  showDescriptionOnImage: false,
  showCheckMarkOnCard: false,
  tagFilterCollapseVisible: true,
  categoryFilterCollapseVisible: false,
  // Title configuration
  title: {
    mainTitle: {
      content: 'Available Project Modules',
      type: HeadingType.H2
    }
  },

  // Pagination settings
  paginationConfig: DEFAULT_PAGINATION_CONFIG,

  // Filtering configurations
  selectConfig: DEFAULT_SELECT_CONFIG,
  menuConfig: DEFAULT_MENU_CONFIG,
  menuConfigVisible: true,

  // Dynamic pagination for large datasets
  isDynamicPagination: false,

  // Grid view control buttons
  buttons: GRID_VIEW_BUTTONS,

  // Initially empty items array - will be populated by component
  items: []
};
